// @flow
import { Icon } from 'semantic-ui-react';
import React from 'react';

export const FolderIcon = ({ color, opened = false }) => (
  <Icon color={color} name={opened ? 'folder open' : 'folder'} />
);
